module.exports = __webpack_public_path__ + "static/img/yiliaotian.c52e7ff4.png";